import type { InputFrame } from "./game-types";

const GAME_KEYS = new Set([
  "KeyA",
  "KeyD",
  "KeyW",
  "Space",
  "KeyE",
  "KeyF",
  "KeyR",
  "KeyQ",
  "ShiftLeft",
  "ShiftRight",
  "KeyS",
]);

export class KeyboardInput {
  private readonly held = new Set<string>();
  private readonly pressed = new Set<string>();

  constructor() {
    window.addEventListener("keydown", this.onKeyDown, { passive: false });
    window.addEventListener("keyup", this.onKeyUp, { passive: false });
    window.addEventListener("blur", this.clear);
  }

  destroy(): void {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
    window.removeEventListener("blur", this.clear);
  }

  read(): InputFrame {
    const left = this.held.has("KeyA");
    const right = this.held.has("KeyD");
    const frame: InputFrame = {
      moveX: left === right ? 0 : left ? -1 : 1,
      jumpPressed: this.consume("KeyW") || this.consume("Space"),
      attackPressed: this.consume("KeyE"),
      specialPressed: this.consume("KeyF"),
      grabPressed: this.consume("KeyR"),
      shieldPressed: this.consume("KeyQ"),
      shieldHeld: this.held.has("KeyQ"),
      dashHeld: this.held.has("ShiftLeft") || this.held.has("ShiftRight"),
      downHeld: this.held.has("KeyS"),
    };
    return frame;
  }

  private consume(code: string): boolean {
    const wasPressed = this.pressed.has(code);
    this.pressed.delete(code);
    return wasPressed;
  }

  private readonly onKeyDown = (event: KeyboardEvent): void => {
    if (GAME_KEYS.has(event.code)) {
      event.preventDefault();
    }
    if (!event.repeat) {
      this.pressed.add(event.code);
    }
    this.held.add(event.code);
  };

  private readonly onKeyUp = (event: KeyboardEvent): void => {
    if (GAME_KEYS.has(event.code)) {
      event.preventDefault();
    }
    this.held.delete(event.code);
  };

  private readonly clear = (): void => {
    this.held.clear();
    this.pressed.clear();
  };
}
